import React from 'react';

type TrendUpIconProps = React.SVGProps<SVGSVGElement>;

const TrendUpIcon: React.FC<TrendUpIconProps> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 7H21M21 7V15M21 7L13 15L9 11L3 17"
        stroke="#204865"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TrendUpIcon;
